import React, { Component } from 'react';
import { func } from 'prop-types';
import { withRouter } from 'react-router';
import { throttle } from 'lodash';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { connect } from 'react-redux';
import { closeConfirmDialog, openConfirmDialog } from '../actions/dialog/dialogActions';

import { keepAlive, loggedIn } from '../lib/auth.js';

import portalTheme from '../themes/portalTheme';


class AppPage extends Component {
  static propTypes = {
    closeAlertDialog: func,
    openErrorDialog: func,
  };

  constructor(props) {
    super(props);

    this.warningInterval = 1080000; // @TODO set back to 1 minute for testing - 110000
    this.logoutInterval = 120000; // 2 minutes

    this.logoutTimeoutId = null;
  }

  componentDidMount() {
    if (loggedIn()) {
      this.warningTimeoutId = setTimeout(this.timeoutWarning, this.warningInterval);
      this.props.closeConfirmDialog();
    } else {
      this.warningTimeoutId = null;
      this.props.closeConfirmDialog();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.logoutTimeoutId);
    clearTimeout(this.warningTimeoutId);
  }

  logout = () => {
    this.props.closeConfirmDialog();
    this.props.router.replace('/logout');
  };

  resetAndClearWarningTimeout = throttle(() => {
    if (loggedIn()) {
      clearTimeout(this.warningTimeoutId);
      this.warningTimeoutId = setTimeout(this.timeoutWarning, this.warningInterval);
    }
  }, this.warningInterval);

  resetTimeout = () => {
    this.resetAndClearWarningTimeout();
    keepAlive();
    clearTimeout(this.logoutTimeoutId);

    this.warningTimeoutId = setTimeout(this.timeoutWarning, this.warningInterval);

    this.props.closeConfirmDialog();
  };

  timeoutWarning = () => {
    this.logoutTimeoutId = setTimeout(this.logout, this.logoutInterval);

    this.props.openConfirmDialog({
      title: 'You are about to be logged out due to inactivity',
      content: 'Would you like to extend your current session?',
      cancelCallback: this.logout,
      okCallback: this.resetTimeout,
      cancelLabel: 'Log out',
      okLabel: 'Extend session',
    });
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <section
          onClick={this.resetAndClearWarningTimeout}
          onKeyPress={this.resetAndClearWarningTimeout}
        >
          {this.props.children}
        </section>
      </MuiThemeProvider>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  openConfirmDialog: (dialog) => dispatch(openConfirmDialog(dialog)),
});

export default connect(null, mapDispatchToProps)(withRouter(AppPage));



// WEBPACK FOOTER //
// ./src/components/AppPage.js